import type { AgentThread } from "src/stores/agent";

export type ThreadDateGroup =
  | "Today"
  | "Yesterday"
  | "Previous 7 Days"
  | "Older";

const ORDERED_GROUPS: ThreadDateGroup[] = [
  "Today",
  "Yesterday",
  "Previous 7 Days",
  "Older",
];

const getDateGroup = (
  threadDate: Date,
  now: Date
): ThreadDateGroup => {
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  const startOf7DaysAgo = new Date(startOfToday);
  startOf7DaysAgo.setDate(startOf7DaysAgo.getDate() - 7);

  if (threadDate >= startOfToday) {
    return "Today";
  }
  if (threadDate >= startOfYesterday) {
    return "Yesterday";
  }
  if (threadDate >= startOf7DaysAgo) {
    return "Previous 7 Days";
  }
  return "Older";
};

export const groupThreadsByDate = (
  threads: AgentThread[]
): Array<{ group: ThreadDateGroup; threads: AgentThread[] }> => {
  const now = new Date();
  const grouped = new Map<ThreadDateGroup, AgentThread[]>();

  for (const thread of threads) {
    const threadDate = thread.updated_at
      ? new Date(thread.updated_at)
      : new Date(0);
    const group = getDateGroup(threadDate, now);
    const existing = grouped.get(group);
    if (existing) {
      existing.push(thread);
    } else {
      grouped.set(group, [thread]);
    }
  }

  return ORDERED_GROUPS.filter((group) => grouped.has(group)).map((group) => ({
    group,
    threads: grouped.get(group)!,
  }));
};
